'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _inputNumber = require('./inputNumber');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputComponent = function (_React$Component) {
	(0, _inherits3.default)(InputComponent, _React$Component);

	function InputComponent(props) {
		(0, _classCallCheck3.default)(this, InputComponent);

		var _this = (0, _possibleConstructorReturn3.default)(this, (InputComponent.__proto__ || (0, _getPrototypeOf2.default)(InputComponent)).call(this, props));

		_this.state = { value: props.value };
		return _this;
	}

	(0, _createClass3.default)(InputComponent, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.setState({ value: nextProps.value });
		}
	}, {
		key: 'handleChange',
		value: function handleChange(e) {
			var value = e.target.validity.valid ? e.target.value : this.state.value;
			this.setState({ value: value });
			this.props.onChange && this.props.onChange(e);
		}
	}, {
		key: 'render',
		value: function render() {
			var className = (0, _classnames2.default)((0, _defineProperty3.default)({
				'mk-input': true
			}, this.props.className, !!this.props.className));

			return _react2.default.createElement(_input2.default, (0, _extends3.default)({}, this.props, {
				value: this.state.value,
				className: className,
				onChange: this.handleChange.bind(this)
			}));
		}
	}]);
	return InputComponent;
}(_react2.default.Component);

InputComponent.Search = _input2.default.Search;
InputComponent.Group = _input2.default.Group;
InputComponent.Number = _inputNumber2.default;
InputComponent.TextArea = _input2.default.TextArea;

exports.default = InputComponent;
module.exports = exports['default'];